<template>
  <div class="text-center">
    <p class="text-2xl font-semibold text-[#4A148C]">
      {{ formattedTime }}
    </p>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue';

const props = defineProps({
  expireTime: {
    type: String,
    required: true,
  },
});

const emits = defineEmits(['expired']);
const timeLeft = ref(0);
let interval = null;

const calculateTimeLeft = () => {
  const expireAt = new Date(props.expireTime).getTime();
  const now = Date.now();
  const diff = Math.floor((expireAt - now) / 1000);
  return diff > 0 ? diff : 0;
};

const formattedTime = computed(() => {
  const minutes = Math.floor(timeLeft.value / 60);
  const seconds = timeLeft.value % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
});

const startTimer = () => {
  clearInterval(interval);
  timeLeft.value = calculateTimeLeft();

  if (timeLeft.value <= 0) {
    emits('expired');
    return;
  }

  interval = setInterval(() => {
    if (timeLeft.value > 0) {
      timeLeft.value--;
    } else {
      clearInterval(interval);
      emits('expired');
    }
  }, 1000);
};

const resetTimer = () => {
  clearInterval(interval);
  timeLeft.value = calculateTimeLeft();
  startTimer();
};

onMounted(() => {
  startTimer();
});

onUnmounted(() => {
  clearInterval(interval);
});

defineExpose({ resetTimer });

watch(() => props.expireTime, () => {
  resetTimer();
});
</script>
